module.exports = __webpack_public_path__ + "img/overlay_process.9bf49a91.svg";